// import { WHITELIST } from '@/composables/requestUrl';
import { userLogin } from '~/stores/userLogin'
// 正式环境地址
const proUrl = 'https://learning.qingmaoedu.com/api/v1.0'
// 测试环境地址
const devUrl = 'http://127.0.0.1:7001/api/v1.0'
// const devUrl = 'https://learning.qingmaoedu.com/api/v1.0'



let isTest = process.env.NODE_ENV === 'development'
// 注意一定要判断!process.server，否则会报错【location is not defined】
if (!process.server) {
    // 如果当前的host 是 myweb-test.com 那么isTest就设为ture
    isTest = isTest || ['myweb-test.com'].includes(location.host) || false
} else {
    // 判断服务端的环境变量中的IS_DEV是否为TRUE
    isTest = isTest || process.env.IS_DEV === 'TRUE' || false
}

export const BASEURL: string = isTest ? devUrl : proUrl;//全局后台服务器请求地址
// export const BASEURL: string =  proUrl;//全局后台服务器请求地址


//定义ts变量类型接口
interface HttpParms {
    baseURL?: string,  //请求的基本URL，即后台服务器地址，（若服务器请求地址只有一个，可不填）
    url: string,      //请求api接口地址
    method?: any,   //请求方法
    query?: any,       //添加查询搜索参数到URL
    body?: any         //请求体
}

/**
 * 网络请求方法
 * @param obj 请求参数
 * @returns 响应结果
 */

import { ElMessage } from 'element-plus'
import { tokenName } from '~/stores/tokenName';

//GET 请求
export const getRequired = async (obj: HttpParms) => {
    const { data, status, error, refresh, clear } = await useFetch(
        (obj.baseURL ?? BASEURL) + obj.url,
        {
            method: "GET",
            query: obj?.query ?? null,
            body: obj?.body ?? null,
            key: generateUUID(),
            onRequest({ request, options }) {
                // 添加白名单判断（判断是否携带 token）
                if (!WHITELIST.includes(obj.url)) {
                    // 设置请求报头
                    options.headers = options.headers || {}
                    /**如果接口需求携带token请求，则可先自行使用官方的useCookie()方法设置Cookie存储后，再使用useCookie()方法，取出token使用。如下例子：*/
                    const token = useCookie(tokenName)
                    //@ts-ignore
                    // options.headers.Authorization = 'Bearer ' + token.value || null
                    options.headers.set('Authorization', 'Bearer ' + token.value || null)
                }
            },
            // 响应处理
            onResponse({ request, response, options }) {
                const data = response._data;
                // responseData.value = data
                if (data.code === 200 || data.code === 2000) {
                    // resolve(data.data);
                    if (data.msg == '登录成功') {
                        ElMessage({
                            message: data.msg,
                            type: 'success'
                        })
                    }
                } else {
                    ElMessage({
                        message: data.msg,
                        type: 'error'
                    })
                    console.log("错误的信息为 === ", data.data)
                    // reject(new Error(data.message || '响应状态码不是 200或者 2000'));
                }
            },
            // 响应错误处理
            onResponseError({ request, response, options }) {
                if (response) {
                    const data = response._data;
                    if (data.code === 401) {
                        ElMessage({
                            message: '登录信息过期，请重新登录',
                            type: 'error'
                        })
                        initCookie();
                        const loginStore = userLogin();
                        loginStore.isLogin = false
                        location.reload();
                        return navigateTo(`/`)
                    } else {
                        if (data.msg) {
                            ElMessage({
                                message: data.msg,
                                type: 'error'
                            })
                        }
                    }
                    // reject(new Error(response._data.message));
                } else {
                    ElMessage({
                        message: '服务器链接失败或未响应',
                        type: 'error'
                    })
                    // reject(new Error('服务器链接失败或没有响应'));
                }
            },
            // 请求错误处理
            onRequestError({ request, options, error }) {
                // console.log("服务器链接失败!");
                ElMessage({
                    message: '请求失败,服务器链接失败',
                    type: 'error'
                })
                console.log('error is ', error)
                // reject(error);
            }
        },
    )

    return {
        // res,
        data,
        status, error, refresh, clear
    };
}
//POST 请求
export const postRequired = async (obj: HttpParms) => {
    const { data, status, error, refresh, clear } = await useFetch(
        (obj.baseURL ?? BASEURL) + obj.url,
        {
            method: "POST",
            query: obj?.query ?? null,
            body: obj?.body ?? null,
            key: generateUUID(),
            onRequest({ request, options }) {
                // 添加白名单判断（判断是否携带 token）
                if (!WHITELIST.includes(obj.url)) {
                    // 设置请求报头
                    options.headers = options.headers || {}
                    /**如果接口需求携带token请求，则可先自行使用官方的useCookie()方法设置Cookie存储后，再使用useCookie()方法，取出token使用。如下例子：*/
                    const token = useCookie(tokenName)
                    //@ts-ignore
                    // options.headers.Authorization = 'Bearer ' + token.value || null
                    options.headers.set('Authorization', 'Bearer ' + token.value || null)
                }
            },
            // 响应处理
            onResponse({ request, response, options }) {
                const data = response._data;
                // responseData.value = data
                if (data.code === 200 || data.code === 2000) {
                    // resolve(data.data);
                    //这里就不让用户查看到获取成功的提示，我们自己去写这个提示的内容
                    if (data.msg == '登录成功') {
                        ElMessage({
                            message: data.msg,
                            type: 'success'
                        })
                    }
                } else if (data.data) {
                    ElMessage({
                        message: data.msg,
                        type: 'error'
                    })
                    console.log("错误的信息为 === ", data.data)
                    // reject(new Error(data.message || '响应状态码不是 200或者 2000'));
                }
            },
            // 响应错误处理
            onResponseError({ request, response, options }) {
                if (response) {
                    const data = response._data;
                    if (data.code === 401) {
                        ElMessage({
                            message: '登录信息过期，请重新登录',
                            type: 'error'
                        })
                        const loginStore = userLogin();
                        loginStore.isLogin = false
                    } else {
                        ElMessage({
                            message: data.msg ?? data.message,
                            type: 'error'
                        })
                    }

                    // reject(new Error(response._data.message));
                } else {
                    ElMessage({
                        message: '服务器链接失败或未响应',
                        type: 'error'
                    })
                    // reject(new Error('服务器链接失败或没有响应'));
                }
            },
            // 请求错误处理
            onRequestError({ request, options, error }) {
                // console.log("服务器链接失败!");
                ElMessage({
                    message: '请求失败,服务器链接失败',
                    type: 'error'
                })
                console.log('error is ', error)
                // reject(error);
            }
        },
    )
    return {
        // res,
        data,
        status, error, refresh, clear
    };
}

//其他的请求
export const required = async (obj: HttpParms) => {
    const { data, status, error, refresh, clear } = await useFetch(
        (obj.baseURL ?? BASEURL) + obj.url,
        {
            method: obj?.method ?? "GET",
            query: obj?.query ?? null,
            body: obj?.body ?? null,
            key: generateUUID(),
            onRequest({ request, options }) {
                // 添加白名单判断（判断是否携带 token）
                if (!WHITELIST.includes(obj.url)) {

                    // 设置请求报头
                    options.headers = options.headers || {}
                    /**如果接口需求携带token请求，则可先自行使用官方的useCookie()方法设置Cookie存储后，再使用useCookie()方法，取出token使用。如下例子：*/
                    const token = useCookie(tokenName)
                    //@ts-ignore
                    options.headers.Authorization = 'Bearer ' + token.value || null
                }

            },
            // 响应处理
            onResponse({ request, response, options }) {
                console.log('请求的body为 == ', this.body)
                const data = response._data;
                // responseData.value = data

                if (data.code === 200 || data.code === 2000) {
                    // resolve(data.data);
                    if (data.msg != '获取成功') {
                        ElMessage({
                            message: data.msg,
                            type: 'success'
                        })
                    }
                } else {
                    ElMessage({
                        message: data.msg,
                        type: 'error'
                    })
                    console.log("错误的信息为 === ", data.data)
                    // reject(new Error(data.message || '响应状态码不是 200或者 2000'));
                }
            },
            // 响应错误处理
            onResponseError({ request, response, options }) {
                if (response) {
                    const data = response._data;
                    if (data.code === 401) {
                        ElMessage({
                            message: '登录信息过期，请重新登录',
                            type: 'error'
                        })
                        const loginStore = userLogin();
                        loginStore.isLogin = false
                    } else {
                        ElMessage({
                            message: data.msg ?? data.message,
                            type: 'error'
                        })
                    }

                    // reject(new Error(response._data.message));
                } else {
                    ElMessage({
                        message: '服务器链接失败或未响应',
                        type: 'error'
                    })
                    // reject(new Error('服务器链接失败或没有响应'));
                }
            },
            // 请求错误处理
            onRequestError({ request, options, error }) {
                // console.log("服务器链接失败!");
                ElMessage({
                    message: '请求失败,服务器链接失败',
                    type: 'error'
                })
                console.log('error is ', error)
                // reject(error);
            }
        },

    )
    return {
        // res,
        data,
        status, error, refresh, clear
    };

}


function generateUUID() {
    let d = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
}
